// extracted by mini-css-extract-plugin
export default {"__live-label":"GoingLiveModal___live-label__1LolC","__countdown-text":"GoingLiveModal___countdown-text__tI71q","--hide":"GoingLiveModal_--hide__4AHTy"};